import { useEffect } from 'react'

export const useOutsideClick = (
  ref: Record<string, any>,
  callback: () => void,
) => {
  const handleClickOutside = (e) => {
    if (!ref?.current?.contains(e.target)) {
      callback()
    }
  }

  useEffect(() => {
    document.addEventListener(
      'click',
      handleClickOutside as (...args: Array<any>) => any,
    )
    return () => {
      document.removeEventListener(
        'click',
        handleClickOutside as (...args: Array<any>) => any,
      )
    }
  }, [ref])
}

export default useOutsideClick
